import CartElementItinerary from "../CartElementItinerary";
import { removeExcursionFromCart } from "../../../actions/cartActions";
import { FC } from "react";
import { useUpdateCart } from "actions/useUpdateCart";
import { useGetExcursionImages } from "modules/excursions/hooks/useGetExcursionImages";

type Props = {
  excursion: any;
};

const CartExcursionEntryItinerary: FC<Props> = (props) => {
  const excursion = props.excursion;
  const { updateCart } = useUpdateCart();
  const { getExcursionImageThumbnail } = useGetExcursionImages({
    excursionId: excursion.excursionId,
  });

  return (
    <CartElementItinerary
      name={excursion.excursionName}
      isOldSolutionForImage={false}
      imageReference={getExcursionImageThumbnail}
      imageCategory="cruiseExcursion"
      remove={async () => {
        await removeExcursionFromCart(
          excursion.itineraryId,
          excursion.excursionId
        );
        await updateCart();
      }}
      linkTo={`/excursion/${excursion.itineraryId}/${excursion.excursionId}`}
      changePassengersLinkText="Change passengers"
      changePassengersLinkTo={`/excursion/${excursion.itineraryId}/${excursion.excursionId}/passengers`}
      dataTest="cartExcursionEntryItinerary"
    >
      <ul className="list-reset my-2 xl:flex-grow">
        {excursion.passengers.map(
          (passenger: { firstName: any; lastName: any }, index: number) => (
            <li
              key={index}
            >{`${passenger.firstName} ${passenger.lastName}`}</li>
          )
        )}
      </ul>
    </CartElementItinerary>
  );
};

export default CartExcursionEntryItinerary;
